import styled, { css } from "styled-components";

// Styled components

export const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  /* background-color: #f6f7f9; */
  justify-content: space-between;
  // min-width: 100px;
  min-width: ${(props) => props.width || "100px"};
  max-width: 70px;
  height: 38px;
  margin: 3px;
`;

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ValueDisplay = styled.div`
  padding: 10px;
  font-size: 14px;
  text-align: center;
  color: #565556;
  font-family: DM Sans;
`;

export const TitleDisplay = styled.p`
  padding: 0px;
  font-size: 14px;
  color: #000000;
  font-family: DM Sans;
  margin-bottom: 2px;
`;

export const IncrementButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cca3cf;
  border: none;
  border-bottom: 1px solid #ffffff;
  border-radius: 3px; // Set general border-radius for all corners initially
  border-bottom-left-radius: 0; // Set specific corner radius to 0
  border-bottom-right-radius: 0; // Set specific corner radius to 0
  color: #333;
  width: 28px;
  height: 18px;
  cursor: pointer;
  &:hover {
    background-color: #c9b2d8;
  }
  &:focus {
    outline: none;
  }

  ${(props) =>
    props.disabled &&
    css`
      background-color: #D3D3D3;
      color: #ffffff;
      cursor: not-allowed;
      &:hover {
        background-color: #D3D3D3;
      }
    `}
`;

export const DecrementButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cca3cf;
  border: none;
  border-radius: 3px; // Set general border-radius for all corners initially
  border-top-left-radius: 0; // Set specific corner radius to 0
  border-top-right-radius: 0; // Set specific corner radius to 0
  color: #333;
  width: 28px;
  height: 18px;
  cursor: pointer;
  &:hover {
    background-color: #c9b2d8;
  }
  &:focus {
    outline: none;
  }

  ${(props) =>
    props.disabled &&
    css`
      background-color: #D3D3D3;
      color: #ffffff;
      cursor: not-allowed;
      &:hover {
        background-color: #D3D3D3;
      }
    `}
`;
